import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { FormControlContainer } from '../../../components/formControlContainer';
import { BuyInControl } from './buyInControl';
import { BuyInRangeControlContainer } from './buyInRangeControlContainer';
import { BuyInRangeDisplay } from './buyInRangeDisplay';
import { CurrencyControl } from './currencyControl';
export const BuyInControlSet = () => {
    return (_jsxs(FormControlContainer, { children: [_jsxs("div", { css: css `
          display: flex;
          flex-direction: row;
          gap: 10px;
          flex-wrap: wrap;
        `, children: [_jsx(BuyInControl, {}), _jsx(CurrencyControl, {}), _jsx(BuyInRangeControlContainer, {})] }), _jsx(BuyInRangeDisplay, {})] }));
};
